import React from "react";
import axios from 'axios';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import '../MoneyTransferComponent/MoneyTransfer.css';
import swal from 'sweetalert';
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { selectedRechargableAmnt, selectedRechargableAmnt1, setAmount, setAmount1, setCreateOrderRes, setCreateOrderRes1, setCreteOrderReq1, setMoneyTransferSurChargeAmount, setMoneyTransferSurChargeAmount1, setMoneyTransferTotalAmount1, setOrderId1 } from "../../redux/misc-data/misc-data.action";
import { setMoneyTransferTotalAmount } from "../../redux/misc-data/misc-data.action";
import { showCreateOrderResponse, showCreateOrderResponse1, showCreateOrderResponseArr } from '../../redux/response/response.action';
import ProgresStatic from '../../assests/images/mtimg.png';
import Avatar from 'react-avatar';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import ProgressGif from '../../assests/images/progress.gif';
import FooterComponet from "../FooterComponent/FooterComponet";
import { TimeScale } from "chart.js";
import { setAmount2, setCreateOrderRes2, setCreteOrderReq2, setMoneyTransferSurChargeAmount2, setMoneyTransferTotalAmount2, setOrderId2, showCreateOrderResponse2 } from "../../redux/billpayDetails/billpay.action";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();
class BillPayMoneyTransfer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            amount: 0,
            statusEnquiryAttempCount: 0,
            createOrderResponseArr: [],
            currentRequestId: null,
            progressStatus: false,
            orderprocessing: '',
            originalAmout: '',
            orderAmount: '',
            calculatePricingFiledLock: false,

            displayErrorMsg: '',
            transfernowBtnBlock: false,
            moneyTransferEnable: true,
            showStatusModal: false,
            displayStatusMsg: '',
            progress: '',
            customerParamName: '',
            customerParamValue: '',

            showRecharge: ''
        }
    }



    calculatePricing() {

        this.setState({
            displayErrorMsg: '',
            showRecharge: ''
        })
        store.dispatch(setMoneyTransferTotalAmount2(''));
        store.dispatch(setMoneyTransferSurChargeAmount2(''));
        store.dispatch(showCreateOrderResponse2(''));
        store.dispatch(setOrderId2(''));
        store.dispatch(setAmount2(''));

        const header = {
            msgType: "CALCULATE_PRICING",
            service: "PRICING",
            // dstService:"CUSTOM_SERVICE",
            channel: "ADMIN",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),//filled by the 3rd party requester
            time: moment().utc(),
            traceId: uuidv4(),
        }

        var pricingUrl = '/api/v1/pricing/calculate';

        const pricingReq = {
            header: header,
            entityId: this.props.agentInfo.id,
            entityType: "RETAILER",
            productTree:
            {
                serviceCode: "VAS",
                categoryCode: 'BILLPAY',//temp value
                productCode: this.props.biillpayOperatorCateGoryCode.toUpperCase()// will be changed

            },
            txnAmount: parseFloat(this.props.billpayAmount).toFixed(2)
        }
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('pricing req:' + JSON.stringify(pricingReq));

        httpClient.post(pricingUrl, pricingReq, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            this.setState({
                progressStatus: false,
                calculatePricingFiledLock: true

            })

            console.log('pricing response msg' + JSON.stringify(response.data.response.msg));
            if (response.data.response.msg == 'SUCCESS') {

                console.log('pricing service response:' + JSON.stringify(response.data))
                store.dispatch(setAmount2(this.props.billpayAmount));
                var totalAmount = parseInt(response.data.txnAmount) +
                    parseInt(response.data.pricingAmount);
                store.dispatch(setMoneyTransferTotalAmount2(totalAmount));
                store.dispatch(setMoneyTransferSurChargeAmount2(response.data.pricingAmount));
                store.dispatch(showCreateOrderResponse2(response.data));
                store.dispatch(setOrderId2(response.data.pricingId));

                this.setState({
                    transfernowBtnBlock: true,
                    showRecharge: 'true'
                })

            } else {

                this.errorMessageCall(response.data.response.displayMsg);
            }
        }).catch(error => {
            this.setState({
                progressStatus: false
            })

            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else if (error.message.includes("timeout")) {
                this.errorMessageCall('Request timed out.');
            } else {
                this.errorMessageCall(error.message);
            }
        })
    }




    errorMessageCall = (message) => {
        this.setState({
            displayErrorMsg: message
        })
    }

    checkBillPayisUp=()=>{
       

        var requesterId=process.env.REACT_APP_MONEYTRANSFER_REQUESTERID;
       
        const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		var statusCheckUrl = '/api/v1/billpay/service/status/'+requesterId;

		httpClient.get(statusCheckUrl, {
			headers
		}
		).then((response) => {

			console.log('status response' + JSON.stringify(response.data));
			if (response.data.response.success == true) {

                var map = new Map();
                if (this.props.billPayOptional != '' && this.props.billPayOptional != undefined
                    && this.props.billPayOptional != null) {
                    map = new Map(Object.entries(this.props.billPayOptional));
                    var mapKeys = [...map.keys()]
                    var maValues = [...map.values()]
        
                    this.setState({
                        customerParamName: mapKeys[0].split('_').join(' '),
                        customerParamValue: maValues[0]
                    })
                } else {
                    this.setState({
                        customerParamName: 'Mobile Number',
                        customerParamValue: this.props.billPayMobile
                    })
                }
        
                const headers = {
                    'Authorization': 'Bearer ' + this.props.token,
                    'client-id': this.props.agentInfo.id,
                    'role': this.props.clientRole
                }
                this.calculatePricing();

			} else {

				swal({
					title: "Sorry!",
					text: response.data.response.displayMsg,
					icon: "warning",
					button: true,
					dangerMode: false,
				}).then(() => {});
			}

		}).catch(error => {
			swal({
                title: "Sorry!",
                text: 'Billpay is disabled now!',
                icon: "warning",
                button: true,
                dangerMode: false,
            }).then(() => {});
			
		})

    }

    componentDidMount() {
        store.dispatch(setMoneyTransferTotalAmount2(''));
        store.dispatch(setMoneyTransferSurChargeAmount2(''));
        this.checkBillPayisUp();      
    }

    componentWillUnmount() {
    }

    handleClose = (event) => {
        event.preventDefault();
        this.setState({
            showStatusModal: false
        })
    }


    enterAmount = (event) => {
        this.setState({
            orderAmount: event.target.value
        })
    }
    createOrder = (event) => {
        event.preventDefault();

        this.setState({
            progress: 'start',
            orderprocessing: 'start',
            transfernowBtnBlock: false
        });

        var header = '';

        header = {
            msgType: "CREATE_ORDER",
            service: "BILLPAY",
            channel: "WHITELABEL",
            requesterId: this.props.clientRequesterId,
            requestId: uuidv4(),
            time: moment().utc(),
        }

        var transaction = '';

        transaction = {
            mobile: this.props.billPayMobile,
            amount: parseFloat(this.props.billpayAmount).toFixed(2),
            operator: this.props.biillpayOperator,
            customerId: '',
            operator_code: ''
        }

        var createOrderRequest = '';

        //const obj = this.props.billPayOptional;

        // alert('current biller name: ' + this.props.curBillerName)

        var billPayMap = new Map(Object.entries(this.props.billPayOptional));
        // alert(JSON.stringify(this.props.billPayOptional))
        // alert(JSON.stringify(billPayMap))
        // var billPayMap=this.props.billPayOptional;
        billPayMap.set("BILLER_NAME", this.props.curBillerName);
        // alert(this.props.billFetchParams);

        const map = new Map(Object.entries(this.props.billFetchParams));
        for (var [key, value] of map.entries()) {
            console.log(key + " = " + value)
            for (let [key, value] of map.entries()) {
                console.log(key + " = " + value);
                billPayMap.set(key, value);
            }
        }
        const obj = billPayMap;
        // alert(JSON.stringify(Object.fromEntries(obj)));

        // alert(JSON.stringify(obj));
        createOrderRequest = {
            header: header,
            device: this.props.deviceInfo,
            transaction: transaction,
            validated: true,
            payment: "PARTNER_BALANCE",
            agentId: this.props.agentInfo.id,
            optional: Object.fromEntries(obj)
        }

        var createOrderUrl = '/api/v1/billpay/order/create';
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        console.log('create order req:' + JSON.stringify(createOrderRequest));

        httpClient.post(createOrderUrl, createOrderRequest, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {


            console.log('create order response' + JSON.stringify(response.data));
           //alert(response.data.response.success+':'+response.data.response.msg);
            if (response.data.response.success == true
                // && response.data.response.msg == 'SUCCESS'
                ) {

                this.setState({
                    progress: 'finished',
                    orderprocessing: 'end',
                })

                store.dispatch(setCreteOrderReq2(createOrderRequest));
                store.dispatch(setCreateOrderRes2(response.data));
                store.dispatch(setMoneyTransferTotalAmount2(this.props.billpayAmount));

                var gotomoneytransferDetails = document.getElementById('gotomoneytransferDetails');
                gotomoneytransferDetails.click();

            } else {
                this.setState({
                    progress: 'finished',
                    orderprocessing: 'end',
                    transfernowBtnBlock: true

                })
                this.errorMessageCall(response.data.response.displayMsg);
            }
        }).catch(error => {
            this.setState({
                progress: 'finished',
                orderprocessing: 'end',
                transfernowBtnBlock: true
            })
            this.setState({
                progressStatus: false
            })


            if (error.message.includes("401")) {
                tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
            } else if (error.message.includes("timeout")) {
                this.errorMessageCall('Request timed out.');
            } else {
                this.errorMessageCall(error.message);
            }
        })
    }

    render() {
        return (
            <div>
                <HeadeCommon />
                <Menu />
                <div class="main">
                    <Link to='/billpay-details'>
                        <button id='gotomoneytransferDetails' hidden={true}></button>
                    </Link>
                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">

                                        <div class="head">
                                            <h3>BillPay Transfer</h3>
                                            <Link to='/billpay'>
                                                <button class="dbbtn" type="button">Back</button>
                                            </Link>
                                        </div>
                                        <div class="benedtls">
                                            <div class="row justify-content-md-center">
                                                <div class="col-12 col-md-6 col-lg-4 order-lg-1">
                                                    <div class="graycard">
                                                        <div class="bankdtl">
                                                            {/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
                                                            <h5>Operator Name</h5>
                                                            <p>{this.props.biillpayOperator}</p>
                                                        </div>
                                                        <hr />
                                                        <div class="bankdtl">
                                                            <h5>{this.state.customerParamName}</h5>
                                                            <p>{this.state.customerParamValue}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12 col-md-6 col-lg-4 order-lg-3">
                                                    <div class="graycard">
                                                        <div class="bankdtl">
                                                            <h5>Retailer Id</h5>
                                                            <p>{this.props.agentInfo.id}</p>
                                                        </div>
                                                        <hr />
                                                        <div class="acntifsc">
                                                            <h5>Retailer Name</h5>
                                                            <p>{this.props.agentInfo.kioskName}</p>
                                                        </div>

                                                        <div class="acntifsc rtxt">
                                                            <h5>Kiosk Code</h5>
                                                            <p>{this.props.agentInfo.kioskCode}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12 col-lg-4 order-lg-2">
                                                    {(this.state.progress == 'start') &&
                                                        <div class="mtprogess d-none d-md-block">
                                                            <img src={ProgressGif} alt="process" class="img-fluid" />
                                                        </div>
                                                    }
                                                    {(this.state.progress == 'finished' ||
                                                        this.state.progress == '') &&
                                                        <div class="mtprogess d-none d-md-block">
                                                            <img src={ProgresStatic} alt="process" class="img-fluid" />
                                                        </div>
                                                    }

                                                    <div class="form-floating input-group amtmrgn">

                                                        <input type="number" class="form-control" id="amt" placeholder="Amount"
                                                            value={this.props.billpayAmount}

                                                            readOnly />

                                                        <label for="amt">Billpay Amount</label>

                                                        {this.state.transfernowBtnBlock == true &&
                                                            <button type="button" class="btn btnmtr"
                                                                onClick={(e) => this.createOrder(e)}
                                                            >Pay Bill</button>
                                                        }
                                                        {this.state.transfernowBtnBlock == false &&
                                                            this.state.orderprocessing == 'start' &&
                                                            <button type="button" disabled class="btn btnmtr"
                                                            >Pay Bill</button>
                                                        }

                                                        {this.state.transfernowBtnBlock == false &&
                                                            this.state.orderprocessing == 'end' &&
                                                            <button type="button" class="btn btnmtr"
                                                                onClick={(e) => this.createOrder(e)}
                                                            >Pay Bill</button>
                                                        }

                                                        {this.state.transfernowBtnBlock == false &&
                                                            this.state.orderprocessing == '' &&
                                                            <button type="button" disabled class="btn btnmtr"
                                                            >Pay Bill</button>
                                                        }



                                                        {this.state.displayErrorMsg != '' &&
                                                            <div class='valid-error'>
                                                                {this.state.displayErrorMsg}
                                                            </div>}
                                                    </div>

                                                    {this.state.showRecharge == 'true' &&
                                                        <div class="amtshow"
                                                        >
                                                            <div class="amntchrg">
                                                                <p>Comission</p>
                                                                <h5>₹ {
                                                                    this.props.surcharge2
                                                                }</h5>
                                                            </div>
                                                            <div class="dbtamt">
                                                                <p>Total Amount</p>
                                                                <h4>₹{
                                                                    parseFloat(this.props.billpayAmount) -
                                                                    parseFloat(this.props.surcharge2)
                                                                }</h4>

                                                            </div>
                                                        </div>}



                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponet />
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        billpayReduce: { biillpayOperator, billPayMobile, billpayAmount, surcharge2,
            transferTotalAmount2, billPayOptional,
            biillpayOperatorCateGoryCode, curBillerName, billFetchParams
        },
        miscReduce: { agentInfo, token, clientRole, clientRequesterId, callBackUrl } },
) => ({
    errorMessage, loginErrorMessage, biillpayOperator, billPayMobile, billpayAmount, surcharge2, transferTotalAmount2, billPayOptional,
    biillpayOperatorCateGoryCode, curBillerName, billFetchParams,
    agentInfo, token, clientRole, clientRequesterId, callBackUrl
});

export default connect(mapStateToProps, null)(BillPayMoneyTransfer);

